const setImageSizes = () => {
	const previewLayers = document.getElementsByClassName('cpb-preview-layers')[0];
	const image = document.getElementsByClassName('cpb-preview-sticky')[0];
	const width = previewLayers.offsetWidth;
	const widthPx = width.toString() + 'px';

	// Set the width and height of the image
	image.style = { height: widthPx, width: widthPx };

	// Collect the canvases
	const canvases = document.querySelectorAll('.konvajs-content canvas');

	canvases.forEach(canvas => {
		canvas.width = width;
		canvas.height = width;
		canvas.style.height = widthPx;
		canvas.style.width = widthPx;
	});
}

setTimeout(() => {
	// setImageSizes();
}, 3000);